import React, { useEffect, useState } from "react";

import Step from "components/MainApp/atoms/Wizard/Step";
import Checkbox from "components/Auth/atoms/forms/CheckboxCostum";
import ItemTags from "components/MainApp/organisms/OrdersV4/Item-Tags";
import LocationSummary from "components/MainApp/organisms/OrdersV4/LocationSummary";
import locationIcon from "assets/images/location-icon.svg";
import styles from "./Step4Order.module.scss"
import i18n from "i18n";
import { Collapse, ListItemButton } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Button, List } from "@material-ui/core";
import Icon from "components/MainApp/atoms/Icon/icon";
import calendarIcon from "assets/images/calendar-icon.svg";
import trashIcon from "assets/images/trash-icon.svg";
import RoundedButton from "components/Auth/atoms/buttons/RoundedButton";
import editIcon from "assets/images/edit-icon.svg";
import recTypeMapping from "../../../data/RecTypeMapping";

export const Step4Order = ({
  order,
  itemsLocateds,
  addedList,
  goBackFunc,
  goStep1Func,
  handleSubmit
}) => {

  const [open, setOpen] = React.useState(false);
  const handleClick = () => {
    setOpen(!open);
  };
  const [detailData, setDetailData] = useState([]);

  useEffect(() => {
    if (order) {
      const recType = recTypeMapping[order.klass];
      let data = [
        {
          title: i18n.t("reason").toUpperCase(),
          value: recType || ""
        },
        {
          title: i18n.t("provider").toUpperCase(),
          value: order.klass == "PUR" ? order.provider?.name : ""
        },
        {
          title: i18n.t("owner").toUpperCase(),
          value: order.owner.first_name || i18n.t("not.available")
        }
      ]
      setDetailData(data);
    }
  }, [order]);

  useEffect(() => {
    addedList.forEach(producto => {
      producto.tags.forEach(tag => {
        // Busca la zona que contiene este tag
        const zona = itemsLocateds.find(z =>
          z.items.some(item => item.tag === tag.tag)
        );
        if (zona) {
          tag.zone = zona.title; // Agrega la zona al tag
        }
      });
    });


  }, [itemsLocateds, addedList]);

  const stepContent = (
    <div style={{width: "100%"}}>
      <ListItemButton onClick={handleClick} className={styles["reception-order-step4-description"]}>
        <article>
          <div>
            <picture>
              <img src={locationIcon} alt="tag icon" />
            </picture>
            <h4>{i18n.t("description")}</h4>
          </div>
          <div>
            {/* <img src={editIcon} alt="edit icon" className={styles["edit-icon"]} onClick={() => goStep1Func()} /> */}
            {open ? <ExpandLess /> : <ExpandMore />}
          </div>

        </article>
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit className="collapse-container">
        <List component="div" disablePadding >
          {detailData.map((item, index) => (
            item.value && item.value !== "" && (
              <div key={index} className={styles["step4-order-item"]}>
                <div className={styles["step4-order-item-title"]}>
                  {item.title}
                </div>
                <div className={styles["step4-order-item-data"]}>
                  {item.value}
                </div>
              </div>
            )
          ))}
        </List>
      </Collapse>

      <div className={styles["step4-order-products-requested"]}>
        <div className={styles["step4-order-products-requested-title"]}>
          {i18n.t("requested.products")}
        </div>
        <div className={styles["step4-order-products-requested-quantity"]}>
          {addedList.length}
        </div>
        <div className={styles["step4-order-products-requested-total"]}>
          {addedList.reduce((acc, item) => acc + item.tags.length, 0)}  {i18n.t("tags")}
        </div>
      </div>

      <div className={styles["step4-order-items"]}>
        {addedList &&
          addedList.map((item) => {
            return (
              <ItemTags
                key={item.sku}
                item={item}
                quantity={item.tags.length}
                expected={item.expectedUnits}
              />
            );
          })}
      </div>

      <div className={styles["step4-order-footer"]}>
        <div
          className={`${styles["cancel-button"]} ${styles["load-movement-items-button"]} ${styles["load-movement-items-clean"]}`}
          onClick={goBackFunc}
        >
          {i18n.t("go.back")}
        </div>
        <div
          className={`${styles["confirm-button"]} ${styles["load-movement-items-button"]} ${styles["load-movement-items-send"]}`}
          onClick={handleSubmit}
        >
          {i18n.t("confirm").toUpperCase()}
        </div>
      </div>
    </div >
  );
  return (
    <div className={styles["reception-order-step-four-container"]}>
      <Step
        title={i18n.t("order.detail")}
        goBackFunc={goBackFunc}
        content={stepContent}
      ></Step>
    </div>
  );
};

export default Step4Order;
